module.exports = __webpack_public_path__ + "images/718bdaddaafc9aa7c69087069185efb1.svg";